// Module
var code = "<div layout=\"column\"> <div layout=\"row\"> <delivery-link class=\"margin-right-5\" id=\"$ctrl.deliveryId\" show-tooltip=\"true\"> </delivery-link> <span>{{$ctrl.start}}</span> </div> <span style=\"white-space:pre-wrap\" flex>{{$ctrl.end}}</span> </div> ";
// Exports
export default code;